import React from "react";
import AROBadge from "../components/ai-ready-ohio/shared/AROBadge/AROBadge";

export type TrackingStatus = "active" | "paused" | "job_changed" | "stopped";

export function certStatusBadge(
  tracking_status: TrackingStatus,
  tracking_status_reason: string | null
): React.ReactElement {
  if (tracking_status === "active") {
    return <AROBadge label="Active" variant="green" />;
  }
  if (tracking_status === "paused") {
    if (tracking_status_reason === "no_linkedin_url") {
      return <AROBadge label="Paused — No LinkedIn" variant="amber" />;
    }
    if (tracking_status_reason === "consecutive_failures") {
      return <AROBadge label="Paused — Scrape Failures" variant="red" />;
    }
    return <AROBadge label="Paused" variant="amber" />;
  }
  if (tracking_status === "job_changed") {
    return <AROBadge label="Job Changed" variant="blue" />;
  }
  // stopped
  if (tracking_status_reason === "window_expired") {
    return <AROBadge label="Stopped — Window Expired" variant="gray" />;
  }
  return <AROBadge label="Stopped" variant="gray" />;
}

export function canReactivate(
  tracking_status: TrackingStatus,
  tracking_status_reason: string | null
): boolean {
  return tracking_status === "paused" && tracking_status_reason === "consecutive_failures";
}

export function isNoLinkedinPause(
  tracking_status: TrackingStatus,
  tracking_status_reason: string | null
): boolean {
  return tracking_status === "paused" && tracking_status_reason === "no_linkedin_url";
}

export function isTerminal(tracking_status: TrackingStatus): boolean {
  return tracking_status === "job_changed" || tracking_status === "stopped";
}

export function stopReasonLabel(reason: string | null): string {
  switch (reason) {
    case "no_linkedin_url":      return "No LinkedIn URL";
    case "consecutive_failures": return "Consecutive Scrape Failures";
    case "window_expired":       return "Tracking Window Expired";
    default:                     return reason ?? "—";
  }
}
